import NextHead from "next/head";
import { useEffect, useState } from "react";

const Head = () => {
  const [theme, setTheme] = useState("light");

  useEffect(() => {
    const getMql = () =>
      window.matchMedia && window.matchMedia("(prefers-color-scheme: dark)");
    const mql = getMql();
    const getBrowserTheme = () => {
      return mql && mql.matches ? "dark" : "light";
    };

    const setColorTheme = () => {
      const browserTheme = getBrowserTheme();
      if (browserTheme !== theme) {
        setTheme(browserTheme);
      }
    };

    setColorTheme();

    if (mql?.addEventListener) {
      mql && mql.addEventListener("change", setColorTheme);
      return () => {
        mql && mql.removeEventListener("change", setColorTheme);
      };
    }
  });

  return (
    <NextHead>
      <meta name="viewport" content="width=1024" />
      <link rel="preconnect" href="https://fonts.gstatic.com" crossOrigin="" />
      <link rel="preconnect" href="https://fonts.googleapis.com" />
      <link rel="preconnect" href="https://fonts.gstatic.com" crossOrigin="" />
      <link
        href="https://fonts.googleapis.com/css2?family=Geist:wght@100..900&display=swap"
        rel="stylesheet"
      />
      <link
        rel="apple-touch-icon"
        sizes="180x180"
        href="/favicons/apple-touch-icon.png"
      />
      <link
        rel="mask-icon"
        href="/favicons/safari-pinned-tab.svg"
        color="#000000"
      />
      <link
        rel="icon"
        type="image/png"
        sizes="32x32"
        href={`/favicons/favicon-32x32-${
          theme === "dark" ? "light" : "dark"
        }.png`}
      />
      <link
        rel="icon"
        type="image/png"
        sizes="16x16"
        href={`/favicons/favicon-16x16-${
          theme === "dark" ? "light" : "dark"
        }.png`}
      />
      <meta name="theme-color" content="#000000" />
    </NextHead>
  );
};

export default Head;
